<div class="table-actions">
  <ng-content select="[tableActions]"></ng-content>
</div>

<div class="table-filters">
  <ng-content select="[tableFilters]"></ng-content>
</div>

<ng-container *ngIf="source$ | async as source; else loading">
  <ngx-datatable
    *ngIf="!isLoading; else loading"
    class="material"
    [rows]="source.data"
    [columns]="fields$ | async"
    [columnMode]="'force'"
    [limit]="itemsPerPage"
    [offset]="itemsPage"
    [count]="itemsCount"
    [rowHeight]="'auto'"
    [externalPaging]="true"
    [headerHeight]="50"
    [selectionType]="rowSelection"
    [scrollbarH]="false"
    [selectAllRowsOnPage]="false"
    [messages]="messages"
    [selected]="selected"
    [externalSorting]="true"
    [sortType]="'multi'"
    [sorts]="sorts"
    (select)="onSelectHandler($event)"
    (sort)="onSortHandler($event)"
    (tableContextmenu)="contextMenuHandler($event)"
    (activate)="onCellClick($event)">
  </ngx-datatable>
  <ngx-datatable-footer *ngIf="pagination">
    <mat-paginator
      [length]="itemsCount"
      [pageSize]="itemsPerPage"
      [pageIndex]="itemsPage"
      [pageSizeOptions]="[5, 10, 50, 100, 300]"
      (page)="changePageHandler($event)">
    </mat-paginator>
  </ngx-datatable-footer>
</ng-container>

<ng-template
  #tableContextMenu
  let-value>
  <section class="table-context-menu">
    <div
      *ngFor="let item of contextMenuActions"
      (click)="item.action(value)">
      {{ item.label }}
    </div>
  </section>
</ng-template>

<ng-template #loading>
  <div
    class="loading-container"
    *ngIf="!isLoadingDataError">
    <ngx-spinner
      [fullScreen]="false"
      name="loadingTable"
      type="square-loader"
      size="medium"
      class="loading-spinner">
    </ngx-spinner>
  </div>
  <div
    class="error-container"
    *ngIf="isLoadingDataError">
    <i class="fas fa-exclamation-triangle fa-5x"></i>
    <p class="main-error-message">
      {{ 'Ops! si è verificato un errore' | translate }}
    </p>
    <p class="second-error-message">
      {{ 'Errore durante il caricamento dei dati' | translate }}
    </p>
    <p class="second-error-message">
      {{ 'Se l\'errore pesiste contattare l\'assitenza' | translate }}
    </p>
  </div>
</ng-template>

<ng-template
  appTemplateCellId="img"
  ngx-datatable-cell-template
  let-row="row"
  let-value="value">
  <img
    *ngIf="value"
    class="img-fluid"
    loading="lazy"
    [src]="value">
</ng-template>

<ng-template
  appTemplateCellId="context"
  ngx-datatable-cell-template
  let-row="row"
  let-value="value">
  <button
    mat-icon-button
    (click)="$event.stopPropagation(); $event.preventDefault(); contextMenuHandler({ event: $event, type: ContextmenuType.body, content: row })">
    <mat-icon>more_vert</mat-icon>
  </button>
</ng-template>

<ng-template
  appTemplateCellId="delete"
  ngx-datatable-cell-template
  let-row="row"
  let-value="value">
  <button
    mat-icon-button
    [matTooltip]="'Elimina' | translate"
    (click)="$event.stopPropagation(); $event.preventDefault(); rowAction.emit({ type: 'delete', item: row })">
    <mat-icon>delete</mat-icon>
  </button>
</ng-template>

<ng-template
  appTemplateCellId="show"
  ngx-datatable-cell-template
  let-row="row"
  let-value="value">
  <button
    mat-icon-button
    [matTooltip]="'Mostra' | translate"
    (click)="$event.stopPropagation(); $event.preventDefault(); rowAction.emit({ type: 'show', item: row })">
    <mat-icon>visibility</mat-icon>
  </button>
</ng-template>

<ng-template
  appTemplateCellId="edit"
  ngx-datatable-cell-template
  let-row="row"
  let-value="value">
  <button
    mat-icon-button
    [matTooltip]="'Modifica' | translate"
    (click)="$event.stopPropagation(); $event.preventDefault(); rowAction.emit({ type: 'edit', item: row })">
    <mat-icon>edit</mat-icon>
  </button>
</ng-template>

<ng-template
  appTemplateCellId="link"
  ngx-datatable-cell-template
  let-row="row"
  let-value="value">
  <button
    mat-icon-button
    [matTooltip]="'Vai alla scheda' | translate"
    class="link-icon-button">
    <mat-icon>link</mat-icon>
  </button>
</ng-template>

<ng-template
  appTemplateCellId="async"
  ngx-datatable-cell-template
  let-row="row"
  let-value="value">
  {{ value | async }}
</ng-template>

<ng-template
  appTemplateCellId="date"
  ngx-datatable-cell-template
  let-row="row"
  let-value="value">
  {{ value | date : 'dd/MM/yyyy' }}
</ng-template>

<ng-template
  appTemplateCellId="date-time"
  ngx-datatable-cell-template
  let-row="row"
  let-value="value">
  {{ value | date : 'dd/MM/yyyy hh:mm:ss' }}
</ng-template>

<ng-content></ng-content>
